import { render } from "./QueueView.vue?vue&type=template&id=40c76a7c"
import script from "./QueueView.vue?vue&type=script&lang=js"
export * from "./QueueView.vue?vue&type=script&lang=js"

import exportComponent from "../../node_modules/vue-loader/dist/exportHelper.js"
const __exports__ = /*#__PURE__*/exportComponent(script, [['render',render]])

export default __exports__